import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChecklistSubitem, ChecklistType, ItemChecklist, TipoSelecaoType } from '../../../service/Checklists';
import { TitleText } from '../../Teams/style/RegisteredTeamsStyle';
import SubItemTypeComponent from './FormModal/SubItemTypeComponent';
import FormSubItemHelpModal from './FormSubItemHelpModal';
import { UserContext, identifierTypesList } from '../../../context/UserContext';
import { trackEventMatomo } from '../../../helpers/matomo';
import RemoveQrCOde from './RemoveQrCOde';
import { FormContext } from '../../../context/FormContext';
import { Button, Checkbox, Divider, FormControl, FormControlLabel, IconButton, InputLabel, NativeSelect, Stack, TextField, Tooltip, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import HelpIcon from '@mui/icons-material/Help';

const key = 'checklists.subitemModal.';
const questionKey = 'checklists.subitemModal.questionTypes.';

type avalicacaoType = {
  nome: string,
  valor: number,
};

export default function FormSubitemModal({
  fatherIndex,
  thisIndex,
  subItem,
  setEditSubModalOpen,
  editSubModalOpen,
  isEditing,
  setEditingForm,
  form,
  item,
  setSubModalOpen,
  selectedIdentifica,
}:
  {
    fatherIndex: number,
    thisIndex: number,
    subItem: ChecklistSubitem,
    form: ChecklistType,
    setEditSubModalOpen: Function,
    editSubModalOpen: boolean,
    isEditing: boolean,
    setEditingForm: Function,
    item: ItemChecklist,
    setSubModalOpen: Function,
    selectedIdentifica: string | undefined
  }) {
  const { t } = useTranslation('translation');
  const { modeloQrCode, setModeloQrCode, qrCodeInfo, setQrCodeInfo } = useContext(FormContext);

  const [helpModal, setHelpModdal] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [subItemType, setSubItemType] = useState(subItem.tipo || 'avaliacao');
  const optionsSelectMap = {
    avaliacao: t(questionKey + 'avaliation'), multiple: t(questionKey + 'multiple'),
    unique: t(questionKey + 'unique'),
    textoCurto: t(questionKey + 'shortText'), textoLongo: t(questionKey + 'longText'),
    list: t(questionKey + 'textList'),
    data: t(questionKey + 'date'), hora: t(questionKey + 'hour'),
    numero: t(questionKey + 'number'), assinatura: t(questionKey + 'signature'),
    email: 'e-mail', telefone: t(questionKey + 'tel'),
    rg: 'RG', cpfcnpj: 'CPF/CNPJ',
    cep: 'CEP', placa: t(questionKey + 'placa')
  };
  const [nome, setNome] = useState(subItem.nome);
  const [preenchimento, setPreenchimento] = useState(subItem.obrigatoriedade?.preenchimento || false);
  const [foto, setFoto] = useState(subItem.foto || false);
  const [comentario, setComentario] = useState(subItem.comentario || false);
  const [peso, setPeso] = useState<number | undefined>(subItem.peso ? Number(subItem.peso) : 0);
  const [conformeOcorrencia, setConformeOcorrencia] = useState(false);
  const [conformeImg, setConformeImg] = useState(false);
  const [naoConformeOcorrencia, setNaoConformeOcorrencia] = useState(false);
  const [naoConformeImg, setNaoConformeImg] = useState(false);
  const [naoAplicaOcorrencia, setNaoAplicaOcorrencia] = useState(false);
  const [naoAplicaImg, setNaoAplicaImg] = useState(false);
  const [preenchImg, setPreenchImg] = useState(subItem.obrigatoriedade?.img || false);
  const [preenchObs, setPreenchObs] = useState(subItem.obrigatoriedade?.ocorrencia || false);
  const [galeriaFoto, setGaleriaFoto] = useState(subItem.galeriaFoto || false);
  const [naoAplica, setNaoAplica] = useState(subItem?.avaliacao?.find((e: avalicacaoType) => e.valor === -1) ? true : false);
  const [avaliacao, setAvaliacao] = useState(subItem.avaliacao ? [...subItem.avaliacao] : null);
  const [threshold, setThreshold] = useState(subItem.threshold);
  const [padrao, setPadrao] = useState<any>(subItem.padrao);
  const [selecao, setSelecao] = useState(subItem.selecao);
  const [padraoLista, setPadraoLista] = useState(subItem.padraoLista);
  const [maxNumberVal, setMaxNumberVal] = useState<number | null>(subItem.maxNumberVal as number);
  const [minNumberVal, setMinNumberVal] = useState<number | null>(subItem.minNumberVal as number);
  const [help, setHelp] = useState(subItem.help);
  const [disable, setDisable] = useState(false);
  const [hideImg, setHideImg] = useState<boolean>(!subItem?.hideImg ? true : false);
  const [hideComment, setHideComment] = useState<boolean>(!subItem?.hideComent ? true : false);
  const [tipoSelecao, setTipoSelecao] = useState<TipoSelecaoType>(subItem.tipoSelecao || 'default');
  const [abrePlano, setAbrePlano] = useState(subItem.abrePlano || false);
  const [geraQrCode, setGeraQrCode] = useState(subItem.geraQrCode || false);
  const [openModalQrCode, setOpenModalQrCode] = useState<boolean>(false);

  const { hierarchyLabel, identifiersByForm, setIdentifiersByForm, acessoPlanoDeAcao } = useContext(UserContext);

  const mapTiposSelecao = {
    default: 'Padrão',
    user: 'Usuarios',
    cliente: hierarchyLabel.cliente,
    local: hierarchyLabel.local,
    conjunto: hierarchyLabel.conjunto,
    unidade: hierarchyLabel.unidade
  };

  const escape = useCallback((e: any): void => {
    trackEventMatomo('formSubitem', 'click', 'modal', 'fecha');
    if (e.key === 'Escape') {
      setEditSubModalOpen(false);
    }
  }, [setEditSubModalOpen]);

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
    subItem.obrigatoriedade?.conforme?.ocorrencia && setConformeOcorrencia(subItem.obrigatoriedade.conforme.ocorrencia);
    subItem.obrigatoriedade?.conforme?.img && setConformeImg(subItem.obrigatoriedade.conforme.img);
    subItem.obrigatoriedade?.naoConforme?.ocorrencia && setNaoConformeOcorrencia(subItem.obrigatoriedade.naoConforme.ocorrencia);
    subItem.obrigatoriedade?.naoConforme?.img && setNaoConformeImg(subItem.obrigatoriedade.naoConforme.img);
    subItem.obrigatoriedade?.NA?.ocorrencia && setNaoAplicaOcorrencia(subItem.obrigatoriedade.NA.ocorrencia);
    subItem.obrigatoriedade?.NA?.img && setNaoAplicaImg(subItem.obrigatoriedade.NA.img);
    subItem.minNumberVal && setMinNumberVal(subItem.minNumberVal);
    subItem.maxNumberVal && setMaxNumberVal(subItem.maxNumberVal);
    subItem.obrigatoriedade?.img && setPreenchImg(subItem.obrigatoriedade?.img);
    subItem.obrigatoriedade?.ocorrencia && setPreenchObs(subItem.obrigatoriedade?.ocorrencia);
    subItem.peso && setPeso(subItem.peso);
  }, [
    escape,
    subItem.obrigatoriedade?.conforme?.ocorrencia,
    subItem.obrigatoriedade?.conforme?.img,
    subItem.obrigatoriedade?.naoConforme?.ocorrencia,
    subItem.obrigatoriedade?.naoConforme?.img,
    subItem.minNumberVal,
    subItem.maxNumberVal,
    subItem.obrigatoriedade?.NA?.ocorrencia,
    subItem.obrigatoriedade?.NA?.img,
    subItem.obrigatoriedade?.img,
    subItem.obrigatoriedade?.ocorrencia,
    subItem.peso
  ]);

  const handleSaveBtn = () => {
    setModeloQrCode({ ...modeloQrCode, ...qrCodeInfo });
    console.log(modeloQrCode);
    trackEventMatomo('formSubitem', 'click', 'button', 'salva');
    const obj: ChecklistSubitem = {
      geraQrCode,
      id: subItem.id,
      nome,
      itemid: item.id,
      avaliacao: subItemType === 'avaliacao' ? avaliacao : null,
      comentario,
      hideImg: hideImg ? false : true,
      hideComent: hideComment ? false : true,
      foto,
      galeriaFoto,
      minNumberVal: subItemType === 'numero' ? minNumberVal : null,
      maxNumberVal: subItemType === 'numero' ? maxNumberVal : null,
      obrigatoriedade: {
        img: preenchImg,
        ocorrencia: preenchObs,
        preenchimento,
        conforme: {
          img: conformeImg,
          ocorrencia: conformeOcorrencia
        },
        naoConforme: {
          img: naoConformeImg,
          ocorrencia: naoConformeOcorrencia
        },
        NA: naoAplica ? {
          img: naoAplicaImg || null,
          ocorrencia: naoAplicaOcorrencia || null
        } : null
      },
      padrao,
      padraoLista: subItemType === 'list' ? padraoLista : null,
      peso: subItemType === 'avaliacao' ? peso : null,
      selecionados: subItem.selecionados ? subItem.selecao && subItem.padrao && (subItem?.selecao?.map(el => { return padrao.includes(el) ? true : false; }) || Array(subItem.selecao?.length).fill(false)) : null,
      selecao,
      threshold,
      tipo: subItemType,
      help,
      tipoSelecao,
      abrePlano,
    };
    const subIdentifi = `${form.id}|${form.versao}|${fatherIndex}|${thisIndex}`;
    const thisIdentifierList = identifiersByForm.find(e => e.formId === form.id)?.identifiersList;
    if (identifierTypesList.includes(subItemType)) {
      if (!thisIdentifierList?.some(e => e.value === subIdentifi)) {
        identifiersByForm.forEach(e => {
          if (e.formId === form.id) {
            e.identifiersList.push({ value: subIdentifi, nome });
          }
        });
      } else {
        identifiersByForm.forEach(e => {
          if (e.formId === form.id) {
            e.identifiersList.forEach(iden => {
              if (iden.value === subIdentifi) {
                iden.nome = nome;
              }
            });
          }
        });
      }
      setIdentifiersByForm([...identifiersByForm]);
    } else if (thisIdentifierList?.some(e => e.value === subIdentifi)) {
      identifiersByForm.forEach(e => {
        if (e.formId === form.id) {
          e.identifiersList = e.identifiersList.filter(iden => iden.value !== subIdentifi);
        }
      });
      setIdentifiersByForm([...identifiersByForm]);
    }
    form.itens[fatherIndex].subitens[thisIndex] = { ...obj };
    setEditingForm({ ...form });
    setIsHidden(true);
    setEditSubModalOpen(false);
    setSubModalOpen(false);
  };

  const WeightInputChange = () => {
    const InputWeightRef = useRef<HTMLInputElement>(null);
    const [pesoState, setPesoState] = useState<number | string>(typeof peso === 'number' && peso >= 0 ? peso : 1);

    return (
      <TextField
        onChange={(e) => {
          trackEventMatomo('formSubitem', 'click', 'button', 'edita valor');
          setPesoState(e.target.value);
        }}
        onBlur={() => {
          if (InputWeightRef && InputWeightRef.current) {
            const value = InputWeightRef.current.value;
            if (isNaN(Number(value)) || Number(value) < 0) {
              setPeso(1);
              setPesoState(1);
            } else {
              setPeso(Number(value));
              setPesoState(Number(value));
            }
          }
        }}
        label={t(key + 'subitemWeight')}
        variant='standard'
        inputProps={{ min: 0, type: 'number', inputMode: 'numeric', pattern: '[0-9]*', style: { textAlign: 'center', width: '100px' } }}
        value={pesoState}
        disabled={!isEditing}
        ref={InputWeightRef}
      />
    );
  };

  useEffect(() => {
    if (subItem.tipo === 'avaliacao') {
      localStorage.setItem('avaliacaoBackup', JSON.stringify(subItem.avaliacao));
    } else if (subItem.tipo === 'multiple' || subItem.tipo === 'unique') {
      localStorage.setItem('selecaoBackup', JSON.stringify(subItem.selecao));
    }
  }, [subItem.avaliacao, subItem.selecao, subItem.tipo]);

  const checkDisable = () => {
    if (!isEditing) {
      return true;
    }
    switch (subItemType) {
      case 'numero':
        if (maxNumberVal && minNumberVal) {
          if ((Number(padrao) > Number(maxNumberVal)) || ((Number(padrao) < Number(minNumberVal)))) {
            return true;
          }
        }
        break;
      case 'email':
        const regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (padrao?.length > 1 && !regexEmail.test(padrao)) {
          return true;
        }
        break;
      case 'telefone':
        if (padrao?.length && padrao?.length <= 11) {
          return true;
        }
        break;
      case "cpfcnpj":
        if (padrao?.length && (padrao?.length !== 14 && padrao?.length !== 18))
          return true;
        break;
      case "cep":
        if (padrao?.length && padrao?.length !== 9)
          return true;
        break;
      case "placa":
        if (padrao?.length && padrao?.length !== 8)
          return true;
        break;
      default:
        return false;
    }
    return false;
  };

  const CheckBoxInput = ({
    label,
    setChange,
    value,
    disable }
    : {
      label: string,
      setChange: Function,
      value: boolean,
      disable: boolean
    }) => {
    return (
      <FormControlLabel
        componentsProps={{ typography: { textAlign: 'start' } }}
        labelPlacement="end"
        control={<Checkbox
          disabled={disable}
          checked={value}
          onChange={() => {
            setChange(!value);
            trackEventMatomo('formSubitem', 'click', 'checkbox', 'habilita valor');
          }}
        />} label={label} />
    );
  };

  const switchTypes = (tipo: string) => {
    switch (tipo) {
      case 'avaliacao':
        return (
          <>
            {acessoPlanoDeAcao
              && <CheckBoxInput
                label={t('checklists.allowActionPlanOpening')}
                disable={!isEditing}
                value={abrePlano}
                setChange={setAbrePlano}
              />}
            <CheckBoxInput
              label={t(key + 'allowPhoto')}
              disable={!isEditing}
              value={hideImg}
              setChange={setHideImg}
            />
            <CheckBoxInput
              label={t(key + 'allowComment')}
              disable={!isEditing}
              value={hideComment}
              setChange={setHideComment}
            />
            <WeightInputChange />
            <Typography variant='h6'>{t(key + 'notAccording')}</Typography>
            <CheckBoxInput
              label={t(key + 'mandatoryPhoto')}
              disable={!isEditing || !hideImg}
              value={naoConformeImg}
              setChange={setNaoConformeImg}
            />
            <CheckBoxInput
              label={t(key + 'mandatoryComment')}
              disable={!isEditing || !hideComment}
              value={naoConformeOcorrencia}
              setChange={setNaoConformeOcorrencia}
            />
            <Typography variant='h6'>{t('checklists.accordingTo')}</Typography>
            <CheckBoxInput
              label={t(key + 'mandatoryPhoto')}
              disable={!isEditing || !hideImg}
              value={conformeImg}
              setChange={setConformeImg}
            />
            <CheckBoxInput
              label={t(key + 'mandatoryComment')}
              disable={!isEditing || !hideComment}
              value={conformeOcorrencia}
              setChange={setConformeOcorrencia}
            />
            {naoAplica && (
              <>
                <Typography variant='h6'>{t('checklists.printConfig.Nao_se_aplica')}</Typography>
                <CheckBoxInput
                  label={t(key + 'mandatoryPhoto')}
                  disable={!hideImg || !isEditing}
                  value={naoAplicaImg}
                  setChange={setNaoAplicaImg}
                />
                <CheckBoxInput
                  label={t(key + 'mandatoryComment')}
                  disable={!hideComment || !isEditing}
                  value={naoAplicaOcorrencia}
                  setChange={setNaoAplicaOcorrencia}
                />
              </>
            )}
            <Divider variant='middle' orientation='horizontal' flexItem />
            {!form.preenchimentoWeb
              && <CheckBoxInput
                label={t(key + 'allowGalery')}
                disable={!hideImg || !isEditing}
                value={galeriaFoto}
                setChange={setGaleriaFoto}
              />
            }
            <FormControlLabel
              componentsProps={{ typography: { textAlign: 'start' } }}
              labelPlacement="end"
              control={<Checkbox
                disabled={!isEditing}
                checked={naoAplica}
                onChange={(e) => {
                  trackEventMatomo('formSubitem', 'click', 'checkbox', 'habilita valor');
                  setNaoAplica(!naoAplica);
                  if (e.target.checked) setAvaliacao((prev) => prev
                    ? [...prev, { NA: true, nome: 'Não se Aplica', valor: -1 }]
                    : [{ NA: true, nome: 'Não se Aplica', valor: -1 }]);
                  else setAvaliacao((prev) => prev && prev.filter(ele => ele.valor >= 0));
                }}
              />} label={t(key + 'fieldNotApply')} />
          </>
        );
      case 'multiple':
      case 'unique':
      case 'list':
      case 'numero':
      case 'assinatura':
        return (
          <>
            <CheckBoxInput
              label={t(key + 'allowPhoto')}
              disable={!isEditing}
              value={foto}
              setChange={setFoto}
            />
            <CheckBoxInput
              label={t(key + 'mandatoryPhoto')}
              disable={!foto || !isEditing}
              value={preenchImg}
              setChange={setPreenchImg}
            />
            <CheckBoxInput
              label={t(key + 'allowComment')}
              disable={!isEditing}
              value={comentario}
              setChange={setComentario}
            />
            <CheckBoxInput
              label={t(key + 'mandatoryComment')}
              disable={!comentario || !isEditing}
              value={preenchObs}
              setChange={setPreenchObs}
            />
            {!form.preenchimentoWeb
              && <CheckBoxInput
                label={t(key + 'allowGalery')}
                disable={!foto}
                value={galeriaFoto}
                setChange={setGaleriaFoto}
              />
            }
          </>
        );
      case 'textoCurto':
      case 'textoLongo':
      case 'email':
      case 'cpfcnpj':
      case 'rg':
      case 'telefone':
      case 'cep':
      case 'placa':
        return (
          <>
            <CheckBoxInput
              label={t(key + 'allowPhoto')}
              disable={!isEditing}
              value={foto}
              setChange={setFoto}
            />
            <CheckBoxInput
              label={t(key + 'mandatoryPhoto')}
              disable={!foto || !isEditing}
              value={preenchImg}
              setChange={setPreenchImg}
            />
            <CheckBoxInput
              label={t(key + 'allowGalery')}
              disable={!foto}
              value={galeriaFoto}
              setChange={setGaleriaFoto}
            />
          </>
        );
      case 'data':
      case 'hora':
        return (
          <>
            <CheckBoxInput
              label={t(key + 'allowComment')}
              disable={!isEditing}
              value={comentario}
              setChange={setComentario}
            />
            <CheckBoxInput
              label={t(key + 'mandatoryComment')}
              disable={!comentario || !isEditing}
              value={preenchObs}
              setChange={setPreenchObs}
            />
          </>
        );
      default: return (<></>);
    }
  };

  function addQrCodeInfo(subitem: any, itemIndex: string, subitemIndex: string) {
    const objectToSet = {
      nome: nome,
      tipo: subItemType,
      posicao: `${itemIndex}||${subitemIndex}`,
    };
    setQrCodeInfo({ [objectToSet.posicao]: { ...objectToSet } });
  }

  useEffect(() => {
    if (subItem.geraQrCode) {
      addQrCodeInfo(subItem, String(fatherIndex), String(thisIndex));
    }
  }, []);

  function verificaIdentifica() {
    if (!selectedIdentifica) {
      return true;
    }
    const identifica = `${subItem.itemid}|${subItem.id}` === selectedIdentifica;
    const selecionado = item?.subitens?.find((elem) => `${elem.itemid}|${elem.id}` === selectedIdentifica);
    if (!identifica) {
      if (!selecionado?.geraQrCode) {
        if (!modeloQrCode) return true;
      }
    } else
      return false;
  }

  useEffect(() => {
    setPadrao('');
  }, [subItemType]);

  function removeKey(type: string) {
    if (type === 'avaliacao') {
      delete subItem.foto;
      delete subItem.comentario;
    }
    if (type !== 'numero') {
      delete subItem.maxNumberVal;
      delete subItem.minNumberVal;
    } if (type !== 'avaliacao') {
      delete subItem.peso;
      delete subItem.avaliacao;
      delete subItem.threshold;
      delete subItem.nota;
      delete subItem.hideComent;
      delete subItem.hideImg;
      delete subItem?.obrigatoriedade?.NA;
      delete subItem.obrigatoriedade?.conforme;
      delete subItem.obrigatoriedade?.naoConforme;
    } if (type !== 'multiple' && type !== 'unique') {
      delete subItem.selecao;
      delete subItem.tipoSelecao;
      delete subItem.selecionados;
      delete subItem.padraoLista;
      delete subItem.padraoMultiple;
    } if (type !== 'assinatura') {
      delete subItem.assinatura;
    }
  }

  useEffect(() => {
    removeKey(subItemType);
  }, [subItemType]);

  return (
    <>
      <FormSubItemHelpModal
        helpModal={helpModal}
        setHelpModal={setHelpModdal}
        setIsHidden={setIsHidden}
        setSubItem={setHelp}
        help={help || null}
        isEditing={isEditing}
      />
      {openModalQrCode
        && <RemoveQrCOde
          component={'subitem'}
          open={openModalQrCode}
          setOpen={setOpenModalQrCode}
          setState={setGeraQrCode}
        />}
      {!isHidden && (
        <>
          <TitleText>
            <div className={`${editSubModalOpen ? "modal is-active" : "modal"}`}>
              <div className="modal-background" onKeyDown={(e) => {
                trackEventMatomo('formSubitem', 'click', 'modal', 'fecha modal');
                escape(e);
              }} onClick={() => {
                trackEventMatomo('formSubitem', 'click', 'modal', 'fecha modal');
                setEditSubModalOpen(false);
              }} />
              <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
                <header className="modal-card-head">
                  <p className="modal-card-title">{t(key + 'subitemConfig')}</p>
                  <Stack
                    width='100%'
                    direction="row"
                    spacing={1}
                    sx={{
                      justifyContent: "flex-end",
                      alignItems: "flex-start",
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        const avaString = localStorage.getItem('avaliacaoBackup');
                        const seleString = localStorage.getItem('selecaoBackup');
                        if (avaString && subItem.tipo === 'avaliacao') {
                          const avaliacaoBackup = JSON.parse(avaString);
                          subItem.avaliacao = avaliacaoBackup;
                          setAvaliacao(avaliacaoBackup || null);
                        } else if (seleString && (subItem.tipo === 'multiple' || subItem.tipo === 'unique')) {
                          const selecaoBackup = JSON.parse(seleString);
                          subItem.selecao = selecaoBackup;
                          setSelecao(selecaoBackup);
                        }
                        setSubModalOpen(false);
                        setEditSubModalOpen(false);
                      }}

                    >
                      <CancelIcon color='error' />

                    </IconButton>
                  </Stack>
                </header>
                <form>
                  <div className="modal-card-body" style={{ overflowY: 'scroll', maxHeight: '70svh' }}>
                    <Stack
                      width='100%'
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      spacing={4}
                    >
                      <Stack
                        width='100%'
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={2}
                      >
                        <TextField
                          fullWidth
                          variant='standard'
                          label={t(key + 'subitemName')}
                          disabled={!isEditing}
                          value={nome}
                          onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edita valor')}
                          onChange={(e) => {
                            setNome(e.target.value);
                          }}
                        />
                        <FormControlLabel
                          componentsProps={{ typography: { textAlign: 'start' } }}
                          control={<Checkbox
                            disabled={!isEditing}
                            checked={preenchimento}
                            onChange={() => {
                              trackEventMatomo('formSubitem', 'click', 'checkbox', 'habilita valor');
                              setPreenchimento(!preenchimento);
                            }}
                          />} label={t(key + 'mandatory')} />
                        {!form.preenchimentoWeb
                          && <Tooltip title={`${t('checklists.Modal.formNeedsIdentifier')}`}>
                            <FormControlLabel
                              componentsProps={{ typography: { textAlign: 'start' } }}
                              control={<Checkbox
                                disabled={!isEditing || verificaIdentifica()}
                                checked={geraQrCode}
                                onChange={() => {
                                  trackEventMatomo('formSubitem', 'click', 'checkbox', 'habilita valor');
                                  if (!geraQrCode) {
                                    setGeraQrCode(true);
                                    subItem.geraQrCode = true;
                                    addQrCodeInfo(subItem, String(fatherIndex), String(thisIndex));
                                  } else {
                                    setOpenModalQrCode(true);
                                  }
                                }}
                              />} label={t('checklists.Modal.generatePreFilledQRCode')} />
                          </Tooltip>}
                        <Divider variant='middle' orientation='horizontal' flexItem />
                        <SubItemTypeComponent
                          tipoSelecao={tipoSelecao}
                          subItemType={subItemType}
                          avaliacao={avaliacao || null}
                          setAvaliacao={setAvaliacao}
                          threshold={threshold}
                          setThreshold={setThreshold}
                          naoAplica={naoAplica}
                          padrao={padrao}
                          setPadrao={setPadrao}
                          selecao={selecao}
                          setSelecao={setSelecao}
                          padraoLista={padraoLista}
                          setPadraoLista={setPadraoLista}
                          maxNumberVal={maxNumberVal}
                          setMaxNumberVal={setMaxNumberVal}
                          minNumberVal={minNumberVal}
                          setMinNumberVal={setMinNumberVal}
                          disable={disable}
                          setDisable={setDisable}
                          subitem={subItem}
                          isEditing={isEditing}
                          form={form}
                        />
                      </Stack>
                      <Stack
                        width='100%'
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={2}
                      >
                        <FormControl fullWidth>
                          <InputLabel variant='standard' htmlFor='uncontrolled-native'>{t(key + 'questionType')}</InputLabel>
                          <NativeSelect
                            variant='standard'
                            inputProps={{
                              name: t(key + 'questionType'),
                              id: 'uncontrolled-native',
                            }}
                            disabled={!isEditing}
                            onChange={(e) => {
                              if (e.target.value === 'avaliacao') {

                                setAvaliacao([{ nome: '1', valor: 0 }, { nome: '2', valor: 1 }]);
                                setPeso(1);
                                setPadraoLista(null);
                                setSelecao(null);
                              } else if (e.target.value === 'multiple' || e.target.value === 'unique') {
                                setSelecao(["0", "1"]);
                                setAvaliacao(null);
                              } else {
                                setAvaliacao(null);
                                setSelecao(null);
                              }
                              setSubItemType(e.target.value);
                            }}
                            onClick={() => trackEventMatomo('formSubitem', 'click', 'select', 'seleciona valor')}
                            defaultValue={subItemType}
                          >
                            {Object.keys(optionsSelectMap).map((e, i) => (
                              <option key={i} value={e}>{optionsSelectMap[e as keyof typeof optionsSelectMap]}</option>
                            ))}
                          </NativeSelect>
                        </FormControl>
                        {(subItemType === 'unique' || subItemType === 'multiple') &&
                          <FormControl fullWidth>
                            <InputLabel variant='standard' htmlFor='uncontrolled-native'>{t('checklists.chooseSelectionType')}</InputLabel>
                            <NativeSelect
                              variant='standard'
                              inputProps={{
                                name: t('checklists.chooseSelectionType'),
                                id: 'uncontrolled-native',
                              }}
                              defaultValue={tipoSelecao}
                              onClick={() => trackEventMatomo('formSubitem', 'click', 'select', 'seleciona valor')}
                              onChange={(event) => {
                                setTipoSelecao(event.target.value as TipoSelecaoType);
                              }}>
                              {Object.keys(mapTiposSelecao).map((tipo, index) => (
                                <option key={index} value={tipo}>{mapTiposSelecao[tipo as keyof typeof mapTiposSelecao]}</option>
                              ))}
                            </NativeSelect>
                          </FormControl>
                        }
                        <Typography variant='h6'>{`${t('options')}:`}</Typography>
                        <Divider variant='middle' orientation='horizontal' flexItem />
                        {switchTypes(subItemType)}
                      </Stack>
                    </Stack>
                  </div>
                  <div className='modal-card-foot'>
                    <div className='buttons'>
                      {isEditing
                        && <Button
                          endIcon={<SaveIcon />}
                          className='button is-success'
                          onClick={handleSaveBtn}
                          disabled={checkDisable()}>
                          {t('save')}
                        </Button>}
                      {!form.preenchimentoWeb &&
                        <Button
                          endIcon={<HelpIcon />}
                          className='button is-warning'
                          onClick={() => {
                            setIsHidden(true);
                            setHelpModdal(true);
                          }}
                        >
                          {!isEditing ? `${t('checklists.viewHelp')}` : `${t(key + 'helpConfig')}`}
                        </Button>}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </TitleText>
        </>
      )
      }
    </>
  );
}